import Vue from 'vue'
import Router from 'vue-router'
import HomeAll from '@/views/homeall'
import Home from '@/views/home'
import Black from '@/views/black'
import Company from '@/views/company'

import VideoPlay from '@/views/video/video'
import Idear from '@/views/sizheng/sizheng'
import Talk from '@/views/else/talk'
import Lcountry from '@/views/else/lcountry'
import Culture from '@/views/else/culture'
import Special from '@/views/else/special'
import Course from '@/views/else/course'
import RedRead from '@/views/redread/redread'
import RedFile from '@/views/redfilm/redfilm'
import phone_play from '@/views/play_phone'
import InforMation from '@/views/information/index'
import Search from '@/views/search/index'
import InforDes from '@/views/information/des'
import Lectrue from '@/views/lecture/index'
import SearchArt from '@/views/searchaiticle/index'
// import PDF from '@/views/pdf/index'
// import Make from '@/views/sizheng/make'
// import SF from '@/views/sizheng/sf'
// import MT from '@/views/sizheng/mt'
// import ZJ from '@/views/sizheng/zj'
import common from '@/utils/common.js'
import { postRequestVisit } from '@/utils/utils'
Vue.use(Router)
const createRouter = () =>
  new Router({
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
      // (function() {

      //   var mta = document.createElement("script");
      //   mta.src = "//pingjs.qq.com/h5/stats.js?v2.0.4";
      //   mta.setAttribute("name", "MTAH5");
      //   mta.setAttribute("sid", "500723471");

      //   var s = document.getElementsByTagName("script")[0];
      //   s.parentNode.insertBefore(mta, s);
      // })();
      (function () {
        var hm = document.createElement('script')
        hm.src = 'https://hm.baidu.com/hm.js?5044b7b7a345fe5a8d6746eaeeb12e26'
        var s = document.getElementsByTagName('script')[0]

        s.parentNode.insertBefore(hm, s)
      })()
      // if(common.userBase!=null){
      //   postRequestVisit('Api/v1/Log/VisitLog', {
      //     productIds: "10",
      //     sourceType: 'PC',
      //     moduleName: to.name,
      //     pageUrl:"https://sz.bjadks.com"+to.path,
      //     previousPageUrl:"https://sz.bjadks.com"+from.path,
      //     userId:common.userBase.UserId,
      //     userName:common.userBase.UserName,
      //     customerCode:common.userBase.ComCode,
      //     customerName:common.userBase.ComName,
      //     customerId:common.userBase.ComId,
      //     actId: 0

      //   })
      // }else{

      //   postRequestVisit('Api/v1/Log/VisitLog', {
      //     productIds: "10",
      //     sourceType: 'PC',
      //     moduleName: to.name,
      //     pageUrl:"https://sz.bjadks.com"+to.path,
      //     previousPageUrl:"https://sz.bjadks.com"+from.path,
      //     userId:0,
      //     userName:'',
      //     customerCode:'',
      //     customerName:'',
      //     customerId:0,
      //     actId: 0
      //   })
      // }

      if (savedPosition) {
        return savedPosition
      } else {
        return { x: 0, y: 0 }
      }
    },
    routes: [
      {
        path: '/',
        name: 'HomeAll',
        component: HomeAll,
        children: [
          {
            path: '',
            name: 'home',
            component: Home,
            meta: {
              keepAlive: true,
              title: '思政云课堂'
            }
          },
          // {
          //     path: "/idear",
          //     name: 'idear',
          //     component: Idear,
          //     meta: {
          //         keepAlive: true,
          //         title: '思政课程'
          //     }
          // },

          {
            path: '/other/talk',
            name: 'talk',
            component: Talk,
            meta: {
              keepAlive: true,
              title: '百场讲坛'
            }
          },
          {
            path: '/other/special',
            name: 'special',
            component: Special,
            meta: {
              keepAlive: true,
              title: '专题学习'
            }
          },
          {
            path: '/other/course',
            name: 'course',
            component: Course,
            meta: {
              keepAlive: true,
              title: '课程思政'
            }
          },
          {
            path: '/other/lcountry',
            name: 'lcountry',
            component: Lcountry,
            meta: {
              keepAlive: true,
              title: '爱党爱国'
            }
          },
          {
            path: '/other/culture',
            name: 'culture',
            component: Culture,
            meta: {
              keepAlive: true,
              title: '传统文化'
            }
          },
          {
            path: '/redread',
            name: 'redread',
            component: RedRead,
            meta: {
              keepAlive: true,
              title: '红色阅读'
            }
          },
          {
            path: '/redfilm',
            name: 'redfilm',
            component: RedFile,
            meta: {
              keepAlive: true,
              title: '红色电影'
            }
          },

          {
            path: '/infor',
            name: 'information',
            component: InforMation,
            meta: {
              keepAlive: true,
              title: '资讯'
            }
          },
          {
            path: '/search',
            name: 'search',
            component: Search,
            meta: {
              keepAlive: true,
              title: '搜索结果'
            }
          },
          {
            path: '/infordes',
            name: 'infordes',
            component: InforDes,
            meta: {
              // keepAlive: true,
              title: '详情'
            }
          },
          {
            path: '/lectrue',
            name: 'lectrue',
            component: Lectrue,
            meta: {
              // keepAlive: true,
              title: '讲师'
            }
          }
          // {
          //     path: "/idear/0",
          //     name: 'make0',
          //     component: Make,
          //     meta: {
          //         keepAlive: true,
          //         title: '思政课程'
          //     }
          // },
          // {
          //     path: "/idear/1",
          //     name: 'make1',
          //     component: MT,
          //     meta: {
          //         keepAlive: true,
          //         title: '思政课程'
          //     }
          // },
          // {
          //     path: "/idear/2",
          //     name: 'make2',
          //     component: ZJ,
          //     meta: {
          //         keepAlive: true,
          //         title: '思政课程'
          //     }
          // },
          // {
          //     path: "/idear/3",
          //     name: 'make3',
          //     component: SF,
          //     meta: {
          //         keepAlive: true,
          //         title: '思政课程'
          //     }
          // },
        ],
        meta: {
          keepAlive: true,
          title: '首页'
        }
      },

      {
        path: '/video/:sizheng/:courseId/:videoId',
        name: 'video',
        component: VideoPlay
      },
      {
        path: '/black/:isfirst/:states', // states  auto = 免登錄 login登錄 reigist 注冊
        name: 'black',
        component: Black
      },
      {
        path: '/company/:isfirst/:states', // states  集团id isfirst = false
        name: 'company',
        component: Company
      },
      // {
      //   path: "/nb/:uid/:enc/:backurl",
      //   name: 'black',
      //   component: Black,
      // },
      {
        path: '/searchariticle',
        name: 'searchariticle',
        component: SearchArt
      },
      {
        path: '/mobile',
        name: 'phone_play',
        component: phone_play
      }
    ]
  })
const router = createRouter()
export default router



// WEBPACK FOOTER //
// ./src/router/index.js